@if (isLoading$ | async) {
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate" />
  </div>
} @else {
  <section class="finding-item">
    <div class="finding-item-subsection">
      <header class="finding-item-header">
        <div class="finding-header__element">
          <div>{{ 'aiFindingPage.idTitle' | labelsProvider | uppercase }}</div>
          <app-copy-button
            class="copy-button"
            [value]="findingModel.id"
            [title]="findingModel.id"
            [isSecondaryFontColor]="true"
          />
        </div>
        <div class="separator">|</div>
        <div class="finding-header__element">
          {{ findingModel.timestamp | date: 'MMM d, y, HH:mm:ss' }}
        </div>
        @if (labelChips().length > 0) {
          <div class="separator">|</div>
          <div class="finding-header__labels">
            @for (chip of labelChips(); track chip.id) {
              <span
                class="finding-label-chip"
                [style.background-color]="chip.backgroundColor"
                [style.border-color]="chip.color"
                [matTooltip]="chip.displayName"
              >
                {{ chip.displayName }}
              </span>
            }
          </div>
        }
      </header>

      <div class="finding-item-summary">
        {{ findingModel.rule.summary }}
      </div>
    </div>
    @if (findingModel.evidence && findingModel.evidence.length >= 1 && findingModel.rule.id !== 'ZN_M00031') {
      <div class="finding-item-subsection">
        <app-evidence
          [evidenceList]="findingModel.evidence"
          [relatedSteps]="findingModel.relatedSteps"
          (evidenceStepClicked)="evidenceStepClicked.emit($event)"
        />
      </div>
    }

    <div class="finding-item-subsection">
      <div>
        {{ 'aiFindingPage.riskReasonCardTitle' | labelsProvider }}
      </div>
      <div>{{ this.findingModel.rule.riskReason }}</div>
    </div>

    <app-security-tag [tags]="owaspRiskTag" />
    <app-security-tag [tags]="attackRiskTag" />

    <div class="finding-item-subsection">
      <div class="finding-item-subsection-header">
        <div class="finding-item-icon-container">
          <lucide-icon name="search" class="finding-item-icon" [size]="16" />
        </div>
        {{ 'aiFindingPage.investigateSuggestionCardTitle' | labelsProvider }}
      </div>
      @if (triageSuggestion.length > 1) {
        <app-timeline [timelineItems]="triageSuggestion" [withIcons]="false" />
      }
      @if (triageSuggestion.length === 1) {
        <div>
          {{ this.findingModel.rule.triageSuggestion }}
        </div>
      }
    </div>

    @if (this.findingModel.rule.fixSuggestion !== '') {
      <div class="finding-item-subsection">
        <div class="finding-item-subsection-header">
          <div class="finding-item-icon-container">
            <lucide-icon name="message-square" class="finding-item-icon" [size]="16" />
          </div>
          {{ 'aiFindingPage.fixSuggestionCardTitle' | labelsProvider }}
        </div>
        @if (fixSuggestion.length > 1) {
          <app-timeline [timelineItems]="fixSuggestion" [withIcons]="false" />
        }
        @if (fixSuggestion.length === 1) {
          <div>
            {{ this.findingModel.rule.fixSuggestion }}
          </div>
        }
      </div>
    }

    @if (showNoData) {
      <div class="no-data-container">
        <app-no-data [inDialog]="true" />
      </div>
    }
  </section>
}
